import dynamic from "next/dynamic";

const LandingFooter = dynamic(() => import("./LandingFooter"));
const WERIFooter = dynamic(() => import("./containers/WERIFooter"));

export default process.env.NEXT_PUBLIC_APP_WL_CODE === "WERI" ? WERIFooter : LandingFooter;
